import { retainSearchParams } from '@tanstack/react-router'
import { DEFAULT_REPORT_PERIOD, parseReportPeriod, type ReportPeriod } from '@repo/shared/reports'

/** Search params of the Reports layout route, shared by every Reports sub-page. */
export interface ReportsSearch {
  /** Absent = the default period, so a plain `/reports` link never writes `?period=this-month`. */
  period?: ReportPeriod
}

/** The URL value for a period: the default is left out of the URL. */
export function toReportsSearchPeriod(period: ReportPeriod): ReportPeriod | undefined {
  return period === DEFAULT_REPORT_PERIOD ? undefined : period
}

/**
 * `validateSearch` of the Reports layout: an unknown `?period=` (or the default) reads as no period. The key is
 * left out rather than set to `undefined`: `retainSearchParams` only fills keys missing from the next search.
 */
export function validateReportsSearch(search: Record<string, unknown>): ReportsSearch {
  const period = toReportsSearchPeriod(parseReportPeriod(search.period))
  return period ? { period } : {}
}

/**
 * Every link or navigation into a Reports sub-page keeps the current `?period=`, so switching Overview → Sales
 * → Today → back never resets the picker. Links that leave Reports don't run these middlewares and drop it.
 */
export const reportsSearchMiddlewares = [retainSearchParams<ReportsSearch>(['period'])]
